import { allRoutes } from "src/constants/AllRoutes";

/** Passed via `location.state` when opening service edit from a supplier's services table. */
export type ServiceEditFromSupplierState = {
  fromSupplierServiceEdit?: boolean;
  supplierId?: string;
  supplierName?: string;
};

export type ParsedServiceEditFromSupplierContext = ServiceEditFromSupplierState & {
  supplierId: string;
};

export function parseServiceEditFromSupplierState(state: unknown): ParsedServiceEditFromSupplierContext | null {
  const s = state as ServiceEditFromSupplierState;
  if (s?.fromSupplierServiceEdit && s?.supplierId) {
    return { ...s, supplierId: s.supplierId };
  }
  return null;
}

export function getServiceEditReturnPath(state: unknown): string {
  const s = parseServiceEditFromSupplierState(state);
  if (s) {
    return `${allRoutes.suppliers}/${s.supplierId}`;
  }
  return allRoutes.services;
}
